import {
    ContentChild,
    Directive,
    Input,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import { UserDataService } from '../../util/user-data.service';
import { assertTemplate } from './has-privilege.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hasFeatureFlag]',
})
export class HasFeatureFlagDirective {
  @ContentChild('elseTemplate') elseTemplate: TemplateRef<any>;

  @Input() set hasFeatureFlag(featureFlag: string) {
    this.flagEnabled = this.checkFeatureFlag(featureFlag);
    if (this.flagEnabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!this.flagEnabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  @Input() set hasFeatureFlagElse(elseTemplate: TemplateRef<any>) {
    assertTemplate('hasFeatureFlagElse', elseTemplate);
    if (!this.flagEnabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(elseTemplate);
      this.hasView = true;
    }
  }

  hasView = false;
  flagEnabled = false;

  featureFlags = this.userDataService.featureFlags;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userDataService: UserDataService
  ) {}

  /**
   * Returns true if the organization has the feature flag with the same slug as featureFlag enabled or if no feature flag is given.
   *
   * @param featureFlagSlug The slug of the feature flag to check
   * @returns Whether the feature flag is enabled or not
   */
  checkFeatureFlag(featureFlagSlug?: string) {
    if (!featureFlagSlug || !this.featureFlags) return false;
    const enabled = !featureFlagSlug.startsWith('!');
    const slug = enabled ? featureFlagSlug : featureFlagSlug.slice(1);
    return (
      this.featureFlags.find((flag) => flag.slug === slug)?.enabled === enabled
    );
  }
}
